// extracted by mini-css-extract-plugin
module.exports = {"medio-empty":"medioEmpty_medio-empty__NZ1rG","title":"medioEmpty_title__T0Zk2"};